import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, FilterButton, IconButton, Popover, TextInput } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useFilter } from '../useFilter';
export function NumberEqualsOperator(props) {
    var _a, _b, _c;
    const { name } = props;
    const filter = useFilter(name);
    const currentValue = (_b = (_a = filter.value) === null || _a === void 0 ? void 0 : _a.eq) !== null && _b !== void 0 ? _b : undefined;
    const [open, setOpen] = useState(false);
    const [newValue, setNewValue] = useState(currentValue);
    const hasNewValue = currentValue !== newValue;
    const handleSetField = () => {
        if (newValue != null) {
            filter.applyValue({
                eq: newValue,
            });
        }
        setOpen(false);
    };
    const handleOnChange = (event) => setNewValue(parseInt(event.target.value, 10));
    return (<Popover shadow="300" open={open} padding={0} onClose={handleSetField} target={<FilterButton appearance={filter.isTouched ? 'draft' : 'default'} onClick={() => setOpen(!open)}>
          {((_c = filter.value) === null || _c === void 0 ? void 0 : _c.eq) || t({ message: 'Select value', comment: 'Search filter: Select value' })}
        </FilterButton>}>
      <Box p="md" gap="md">
        <TextInput placeholder={t({ message: 'Equals', comment: 'Insights: Number range filter: Equals' })} type="number" value={newValue} onChange={handleOnChange}/>
        <IconButton type="button" appearance="secondary" disabled={!hasNewValue} onClick={handleSetField} aria-label={t({ message: 'Click to apply filter', comment: 'Search filter: Number filter apply filter' })}>
          <Falcon icon="check"/>
        </IconButton>
      </Box>
    </Popover>);
}
